import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';

import { Heading, Box, Paragraph } from 'components';
import { formatCountryRegion } from 'utils/formatStrings';

interface ShippingInfoProps {
  address: any;
}

export const ShippingInfo = observer(({ address }: ShippingInfoProps) => {
  return (
    <Box
      sx={{
        justifyContent: 'space-between',
        display: 'flex',
      }}
    >
      <Box>
        <Heading level={2} size='medium'>
          <Trans>Shipping Address</Trans>
        </Heading>
        <Paragraph mt={2} data-test-id='shipping-info-company'>
          {address?.company}
        </Paragraph>
        <Paragraph mt={2} data-test-id='shipping-info-address1'>
          {address.address1}
        </Paragraph>
        <Paragraph mt={2} data-test-id='shipping-info-city'>
          {address.city}
        </Paragraph>
        <Paragraph mt={2} data-test-id='shipping-info-country'>
          {formatCountryRegion(address.country)}
        </Paragraph>
      </Box>
    </Box>
  );
});
